import * as React from "react";
import { useContext } from "react";
import styled, { css } from "styled-components";
import Spinner from "components/common/Spinner";
import Query from "views/components/Query";
import FieldTypesContext from "views/components/contexts/FieldTypesContext";
import LoadingIndicator from "components/common/LoadingIndicator";
import { Row, Col } from "components/bootstrap";
import WidgetFocusContext from "views/components/contexts/WidgetFocusContext";
import useIsLoading from "views/hooks/useIsLoading";
const StyledRow = styled(Row)(
  ({ $hasFocusedWidget }) => css`
    height: ${$hasFocusedWidget ? "100%" : "auto"};
    overflow: ${$hasFocusedWidget ? "auto" : "visible"};
    position: relative;
  `
);
const StyledCol = styled(Col)`
  height: 100%;
`;
const SearchLoadingIndicator = () => {
  const isLoading = useIsLoading();
  return isLoading && /* @__PURE__ */ React.createElement(LoadingIndicator, { text: "Updating search results..." });
};
const SearchResult = React.memo(({ loadingPlaceholder = /* @__PURE__ */ React.createElement(Spinner, null) }) => {
  const fieldTypes = useContext(FieldTypesContext);
  const { focusedWidget } = useContext(WidgetFocusContext);
  const hasFocusedWidget = !!(focusedWidget == null ? void 0 : focusedWidget.id);
  if (!fieldTypes) {
    return loadingPlaceholder;
  }
  return /* @__PURE__ */ React.createElement(StyledRow, { $hasFocusedWidget: hasFocusedWidget }, /* @__PURE__ */ React.createElement(StyledCol, null, /* @__PURE__ */ React.createElement(Query, null), /* @__PURE__ */ React.createElement(SearchLoadingIndicator, null)));
});
SearchResult.displayName = "SearchResult";
export default SearchResult;
